import { Environment, EnvironmentSequence } from '../../Environment';
import Tools from '../../Misc/Tools';
import React from 'react';
import GameManager from '../../GameManager';
import { Globals } from '../../../misc/helpers';
import $ from 'jquery';
import GenericModal from '../../../components/uiElements/regular/GenericModal';
import { customRouter } from '../../../CustomRouter';
import {Windows} from '../../../pages/MainPage'
export default class UnityEnvironment extends Environment {
	private isLocalInitialized: boolean;
	public showbutton: boolean = false;
	private _lastShowbutton: boolean = false;
	public showLoading: boolean = false;
	private _lastShowLoading: boolean = false;
	public showMainMenuPopUp: boolean = false;
	private onForceUpdate: () => void;
	/**
	 * 
	 * @param gameManager A reference to the game manager
	 * @param templateLocation The location of the template html
	 * @param useRelay True to use the relay instead of the build (this only matters if in localhost)
	 * @param props The props to use for the renderer
	 * @param onReady Optional. Called when the environment is ready to render
	 */
	constructor(public gameManager: GameManager, public templateLocation: string, public useRelay: boolean, public props: UnityEnvironmentProps, public onReady?: () => void) {
		super(gameManager, onReady);
	}

	public onLoadingScene() {
		this.showbutton = false;
		this.showLoading = true;
		this.onForceUpdate();
		this._sendMessageToUnity('loading-scene', null);
	}

	public onSceneLoaded() {
		this.showLoading = false;
		this.onForceUpdate();
	}
  
	/**
	 * Initializes the environment
	 */
	public init(): void {
		if(!this._shouldRenderGame()) {
			this.markReady();
		}
		var context = this;
		var listener = (e: any) => {
			if(e.data.type === 'canvas-resize') {
				$('#canvas-loading-external').css({
					width: e.data.widthInPixels + 'px',
					height: e.data.heightInPixels + 'px'
				});

				$('#startscenarioxunity').css({
					position: 'absolute',
					top: 25 + e.data.topInPixels + 'px',
					left: 25 + e.data.leftInPixels + 'px',
					width: '50px',
					height: '50px'
				});
			}
			else if(e.data.type === 'unity-env-loaded-but-not-ready') {
				context.showbutton = true;
				context.onForceUpdate();
				this._sendMessageToUnity('resize', null);
			}
			else if(e.data.type === 'unity-env-ready') {
				console.log('unity env ready');
				context.markReady();
			} else if(e.data.type === 'unity-env-callback') {
				if(window[e.data.callbackId]) {
					(window[e.data.callbackId] as any)(e.data.callbackParam);
				}
			}
		};
		// window.removeEventListener('message', listener)
		window.addEventListener('message', listener);
	}

	/**
     * Instructs the environment to play a sequence
     * @param sequence The sequence to play
     */
	public playSequence(sequence: EnvironmentSequence<UnityProps>) {
		if(!sequence.props) {
			sequence.props = {};
		}

		if(sequence.onDone) {
			(sequence.props as any).onDone = sequence.onDone;
			sequence.onDone = undefined;
		}

		if(sequence.onError) {
			(sequence.props as any).onError = sequence.onError;
			sequence.onError = undefined;
		}

		if(!this._shouldRenderGame()) {
			fetch('https://localhost:44398/SendMessage', {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					//'Access-Control-Allow-Origin': '*'
				},
				body: JSON.stringify({
					Command: 'unity',
					Message: JSON.stringify({ 
						sequenceName: sequence.sequenceName, 
						skipAnimations: sequence.skipAnimations,
						props: {
						  onDone: sequence.onDone,
						  onError: sequence.onError,
						  sequenceProps: sequence.props && (sequence.props as any).sequenceProps ? JSON.stringify((sequence.props as any).sequenceProps) : null
						} 
					  })
				})
			});
			var interval: any = setInterval((onDone, onError) => {
				fetch('https://localhost:44398/SendMessage/HasUnityFinished', {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						//'Access-Control-Allow-Origin': '*'
					}
				}).then(response => response.json()).then((data) => {
					if(data) {
						if(data.finished && interval) {
							clearInterval(interval);
							interval = null;
							if(data.success && onDone) {
								onDone(data.result);
							}
							if(!data.success && onError) {
								onError(data.result);
							}
						}
					}
				});
			}, 1000, (sequence.props as any).onDone, (sequence.props as any).onError);
		} else {
			var props = this._hookUpMethods(sequence.props);
			this._sendMessageToUnity('sendCommand', { 
				sequenceName: sequence.sequenceName, 
				skipAnimations: sequence.skipAnimations,
				props: props
			});
		}
	}

	/**
	 * True if the game should be rendered
	 */
	private _shouldRenderGame(): boolean {
		const isLocalhost = Tools.isLocalhost();
		return !isLocalhost || (isLocalhost && !this.useRelay);
	}

	/**
	 * Sends a message to unity iFrame
	 * @param cmd The command to send
	 * @param value The object to send
	 */
	private _sendMessageToUnity(cmd: string, value: EnvironmentSequence<UnityProps>): void {
		var frame = document.getElementById('unity-environment') as HTMLIFrameElement;
		if(frame && frame.contentWindow) {
			frame.contentWindow.postMessage({
				type: cmd,
				value: value
			}, '*');
		}
	}

	/**
     * Renders the environment
     */
	public render(onForceUpdate: () => void, props: any) {
		this.onForceUpdate = onForceUpdate;
		if(!this._shouldRenderGame() && !this.isLocalInitialized) {
			setTimeout(() => {
				window.postMessage({
					type: 'unity-env-ready'
					}, '*');
			}, 2000);
			
			this.isLocalInitialized = true;
		}

		if(this._lastShowbutton !== this.showbutton && onForceUpdate) {
			this._lastShowbutton = this.showbutton;
			if(this._lastShowbutton) {
				setTimeout(() => {
					document.getElementById('unity-canvas-button').focus();
				}, 250);
			}
			onForceUpdate();
		} else if(this._lastShowLoading !== this.showLoading && onForceUpdate) {
			this._lastShowLoading = this.showLoading;
			onForceUpdate();
		}
		return (
			<div>
				{(this._shouldRenderGame() ? this._renderGame(props) : null)}
			</div>
		);
	}

	private _hookUpMethods(props: any): any {
		var result = {};
		for(let el in props) {
			if(typeof props[el] === 'function') {
				var propName: any = Tools.generateGuid();
				(window as any)[propName] =  (res: string) =>{
					props[el](res);
					delete window[propName];
				};
				(result as any)[el] = propName;
			} else if(typeof props[el] === 'object') {
				var objRes = this._hookUpMethods(props[el]);
				(result as any)[el] = objRes;
			} else {
				(result as any)[el] = props[el];
			}
		}

		return result;
	}
	private _renderGame(props: any): any {

		return (
		<div>
			<iframe tabIndex={-1} id="unity-environment" title="Unity Canvas" frameBorder="0"
					width={this.props.width} height={this.props.height} src={this.templateLocation} 
					style={{
						width: '100%',
						height: '100%',
						transform: 'translate(-50%, -50%)',
						position: 'absolute',
						left: '50%',
						top: '50%'
					}}></iframe>
			{
				
				this.showLoading ? (
					<div id="canvas-loading-external" style={{
						transform: 'translate(-50%, -50%)',
						position: 'absolute',
						left: '50%',
						top: '50%',
						backgroundColor: 'black'
					}}>
						<h1 style={{
							transform: 'translate(-50%, -50%)',
							position: 'absolute',
							left: '50%',
							top: '50%',
						}}>Loading...</h1>
					</div>
					) : (null)}
					<div>
						{this.showbutton? (
						<div>
							<button
								id="startscenarioxunity"
								tabIndex={0}
								style={{
										width: '43px',
										cursor: 'pointer',
										backgroundColor: 'transparent'
								}}
								role="button"
								onClick={() => {
									this.showMainMenuPopUp = true;
									this.onForceUpdate();
								}}>
								<img 
									src="./assets/startscreen/close.png" 
									alt="close" 
									style={{
										
									}} 
								/>
							</button>
							<button id="unity-canvas-button" role="button" aria-label="Press to load the scenario and start it..."
							onClick={() => {
								var context = this;
								context.showLoading = true;
								context.playSequence({
									sequenceName: 'StartScenarioInteraction',
									skipAnimations: "false",
									onDone: () => {
										context.showbutton = false;
										context.onForceUpdate();
									}
								})
							}}
							style={{
								position: 'absolute',
								top: '49%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								width: '430px',
								height: '112px',
								backgroundColor: 'rgba(0, 0, 0, 0)',
								//pointerEvents: 'none'
							}}></button>

							{this.showMainMenuPopUp ? (<GenericModal parameters={{
								text: "Would you like to return to the main menu?",
								okBttn: {
									text: 'Yes',
									onClick: () => {
										props.updateWindow(Windows.MainMenu)
										//window.location.href = process.env.PUBLIC_URL
									}
								},
								cancelBttn: {
									text: 'No',
									onClick: () => {
										this.showMainMenuPopUp = false;
										this.onForceUpdate();
									}
								}
							}}></GenericModal>) : (null)};
						</div>) : (null)}

				</div>	
		</div>
		
		)}
}

export interface UnityProps {}

/**
 * Properties for the environment
 */
export interface UnityEnvironmentProps {
	/**
	 * The width in pixels
	 */
	width: number;

	/**
	 * The height in pixels
	 */
	height: number;
}